import { securityTips } from "@/mocks/statusAndSecurity";
import SectionHeading from "./SectionHeading";

export default function SecuritySection() {
  return (
    <section id="security" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="安全与防仿冒"
          title="找地址的同时，也要避开仿冒页面"
          desc="搜索入口时最容易遇到的坑，是进入外观相似却并非正规的页面。下面六条经验，能帮你快速识别并避开它们。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-1 rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col">
            <div className="relative w-full h-52 md:h-full md:min-h-[260px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20minimal%203D%20illustration%20of%20a%20glossy%20shield%20with%20a%20keyhole%2C%20formed%20by%20soft%20vermillion%20red%20and%20golden%20amber%20gradient%20light%2C%20floating%20on%20a%20deep%20charcoal%20background%2C%20elegant%20security%20concept%20visual%2C%20no%20text%2C%20no%20people%2C%20high%20detail%20editorial%20style&width=900&height=1000&seq=security-97v-2026&orientation=portrait"
                alt="安全访问与防仿冒提示插图"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute left-4 right-4 bottom-4">
                <p className="text-background-50 text-sm leading-relaxed">
                  正规入口通常页面整洁、跳转正常、不索要无关的敏感信息。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {securityTips.map((tip) => (
              <article key={tip.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-lg">
                    <i className={tip.icon}></i>
                  </span>
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">{tip.title}</h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}